module.exports = __webpack_public_path__ + "static/media/iconOne.17dfaf0b.svg";